import { render } from "./articleWidget.vue?vue&type=template&id=73ba7dd7&scoped=true"
import script from "./articleWidget.vue?vue&type=script&lang=js"
export * from "./articleWidget.vue?vue&type=script&lang=js"

import "./articleWidget.vue?vue&type=style&index=0&id=73ba7dd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ba7dd7"]])

export default __exports__